// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table:not(:last-child) {
  margin-bottom: 1.5rem;
}

.table {
  background-color: #fff;
  color: #3f3f46;
}
.table th {
  color: #3f3f46;
}
.table th:not([align]) {
  text-align: left;
}
.table thead {
  background-color: transparent;
}
.table thead td,
.table thead th {
  border-width: 0 0 2px;
  color: #3f3f46;
}
.table tfoot {
  background-color: transparent;
}
.table tfoot td,
.table tfoot th {
  border-width: 2px 0 0;
  color: #3f3f46;
}
.table tbody {
  background-color: transparent;
}
.table tbody tr:last-child td,
.table tbody tr:last-child th {
  border-bottom-width: 0;
}
.table.is-hoverable tbody tr:hover {
  background-color: #fafafa;
}
.table.is-hoverable.is-striped tbody tr:hover {
  background-color: #fafafa;
}
.table.is-hoverable.is-striped tbody tr:hover:nth-child(even) {
  background-color: #f5f5f5;
}
.table.is-striped tbody tr:nth-child(even) {
  background-color: #fafafa;
}

table.table thead th {
  min-width: 60px;
}
table.table td {
  color: #444;
}
table.table td .image {
  width: 1.5rem;
  height: 1.5rem;
}

@media screen and (min-width: 769px) {
  .b-table td,
  .b-table th {
    border: 1px solid #eee;
    border-width: 0 0 1px;
    padding: 0.5em 0.75em;
    vertical-align: top;
  }
}
@media screen and (max-width: 768px) {
  .b-table .table thead {
    display: none;
  }
  .b-table .table tfoot th {
    border: 0;
    display: inherit;
  }
  .b-table .table tr {
    -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
    max-width: 100%;
    position: relative;
    display: block;
    margin-bottom: 3px !important;
  }
  .b-table .table tr td {
    border: 0;
    display: inherit;
    padding: 0.1rem 1rem;
  }
  .b-table .table tr td:last-child {
    border-bottom: 0;
  }
  .b-table .table tr:not(:last-child) {
    margin-bottom: 1rem;
  }
  .b-table .table tr:not([class*=is-]) {
    background: inherit;
  }
  .b-table .table tr:not([class*=is-]):hover {
    background-color: inherit;
  }
  .b-table .table tr.detail {
    margin-top: -1rem;
  }
  .b-table .table tr:not(.detail) td {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: auto;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    text-align: right;
    border-bottom: 1px solid #f5f5f5;
  }
  .b-table .table tr:not(.detail) td:before {
    content: attr(data-label);
    font-weight: 600;
    padding-right: 0.5em;
    text-align: left;
  }
}

.table.is-hoverable.is-striped tbody tr:hover:nth-child(even) {
  background-color: #fafafa;
}

.table-main {
  overflow-x: scroll;
}

.b-table .table-main {
  overflow-x: scroll;
}
.b-table .table {
  border: 0;
  border-radius: 0;
}
.b-table .table-wrapper {
  margin-bottom: 0;
}
.b-table .table-wrapper + .level {
  padding: 1.125rem 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin: 0;
  border-top: rgba(24, 28, 33, 0.06);
  background: #f5f5f5;
}

@media screen and (max-width: 768px) {
  .b-table .table tr {
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
    margin-bottom: 3px !important;
  }
}
.page-item.active .page-link {
  z-index: 0 !important;
  background-color: #d9d9d9;
  color: #3f3f46;
  border-color: #d9d9d9;
}`, "",{"version":3,"sources":["webpack://./packages/common/utils/components/src/lib/Table/TableMobile.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,sBAAA;EACA,cAAA;AACF;AACE;EACE,cAAA;AACJ;AACI;EACE,gBAAA;AACN;AAEE;EACE,6BAAA;AAAJ;AAEI;;EAEE,qBAAA;EACA,cAAA;AAAN;AAIE;EACE,6BAAA;AAFJ;AAII;;EAEE,qBAAA;EACA,cAAA;AAFN;AAME;EACE,6BAAA;AAJJ;AAOM;;EAEE,sBAAA;AALR;AAWI;EACE,yBAAA;AATN;AAYI;EACE,yBAAA;AAVN;AAYM;EACE,yBAAA;AAVR;AAeE;EACE,yBAAA;AAbJ;;AAkBE;EAEE,eAAA;AAhBJ;AAmBE;EACE,WAAA;AAjBJ;AAkBI;EACE,aAAA;EACA,cAAA;AAhBN;;AAsBE;EACE;;IAME,sBAAA;IACA,qBAAA;IACA,qBAAA;IACA,mBAAA;EAvBJ;AACF;AAyBE;EAEI;IACE,aAAA;EAxBN;EA0BI;IACE,SAAA;IACA,gBAAA;EAxBN;EA0BI;IACE,oFACE;IAEF,2CAAA;IACA,eAAA;IACA,kBAAA;IACA,cAAA;IACA,6BAAA;EA1BN;EA6BI;IACE,SAAA;IACA,gBAAA;IACA,oBAAA;EA3BN;EA8BI;IACE,gBAAA;EA5BN;EA+BI;IACE,mBAAA;EA7BN;EAgCI;IACE,mBAAA;EA9BN;EAiCI;IACE,yBAAA;EA/BN;EAkCI;IACE,iBAAA;EAhCN;EAmCI;IACE,oBAAA;IACA,oBAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;IACA,sBAAA;IACA,8BAAA;IACA,iBAAA;IACA,gCAAA;EAjCN;EAoCI;IACE,yBAAA;IACA,gBAAA;IACA,oBAAA;IACA,gBAAA;EAlCN;AACF;;AAuCA;EACE,yBAAA;AApCF;;AAuCA;EACE,kBAAA;AApCF;;AAwCE;EACE,kBAAA;AArCJ;AAuCE;EACE,SAAA;EACA,gBAAA;AArCJ;AAwCE;EACE,gBAAA;AAtCJ;AAwCI;EACE,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,SAAA;EACA,kCAAA;EACA,mBAAA;AAtCN;;AA2CA;EAGM;IACE,2CAAA;IACA,6BAAA;EA1CN;AACF;AA+CA;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AA7CF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
